import type { Weekend } from '../types/showcase';

export const eventYear = 2026;

export const eventHours = '12pm – 5pm';

export const homesSince1996 = '450+';

export const weekends: Weekend[] = [
  { label: 'Opening weekend', dates: 'January 16–18', days: 'Fri, Sat & Sun' },
  { label: 'Weekend two', dates: 'January 23–25', days: 'Fri, Sat & Sun' },
  { label: 'Closing weekend', dates: 'Jan 30 – Feb 1', days: 'Fri, Sat & Sun' },
];

export const aboutText =
  'Since 1996 this longstanding event has been hosted by the Cape Coral Construction Industry Association. Professionally designed model and custom homes are showcased during three weekends in January and February. Enjoy viewing luxury show homes to attainably priced homes, from innovative to elegant, all located throughout the City of Cape Coral. Attendees recognize the Showcase as “the source” of inspiration for the latest in home building and design trends.';

export const links = {
  vote: 'https://news-press.gannettcontests.com/2026-CCCIA-Builders-Home-Showcase/gallery',
  printableMap: 'https://members.cccia.org/events/details/cccia-2026-builders-showcase-of-homes-1905',
  gatewayPdf:
    'https://buildersshowcaseofhomes.com/wp-content/uploads/2024/01/Article-A-Gateway-to-Southwest-Florida-Dream-Homes.pdf',
  builderRegistration: 'https://buildersshowcaseofhomes.com/builder-registration/',
  fundraiser: 'https://buildersshowcaseofhomes.com/event-fundraiser/',
};

export const magazine = {
  pickupDate: 'January 14th, 2026',
  note: 'Three unique covers are featured — one for each weekend. Browse every page online, or pick up a hard copy at the CCCIA office.',
};

export const contact = {
  org: 'Cape Coral Construction Industry Association',
  street: '4720 SE 15th Avenue, Suite 120',
  city: 'Cape Coral, FL 33904',
  phone: '239-772-0027',
  phoneHref: 'tel:+12397720027',
  email: 'info@cccia.org',
};

export const testimonial = {
  quote:
    'The Builders’ Showcase of Homes has truly impressed me as a first-time participant with a model home entry. The fact that they attracted hundreds in walk-through traffic over just three weekends is a testament to their reach and appeal. What’s even more impressive is that this led to the execution of a handful of contracts!',
  more:
    'Looking forward to entering next year. Well done, CCCIA’s Builders Showcase of Homes! I also really appreciate the emails from the CCCIA regarding new changes in building code and other very helpful information they provide on a daily and weekly basis to all their members. This is instrumental for Builders keeping up with the constant changes in our industry. Lynn and the CCCIA are instrumental with knowledge and experience that helps southwest Florida contractors and builders.',
  name: 'Jason Foskey',
  role: 'Owner, Coastal Craft Homes',
  logo: 'https://buildersshowcaseofhomes.com/wp-content/uploads/2023/12/Coastal-Craft-Homes.png',
};
